import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.473 2.527V10.2L7.9 6.627a.527.527 0 1 0-.746.746l4.473 4.473a.525.525 0 0 0 .371.154h.004a.525.525 0 0 0 .37-.153l.001-.002 4.473-4.472a.527.527 0 1 0-.746-.746L12.527 10.2V2.527a.527.527 0 1 0-1.054 0ZM.75 16.602a4.602 4.602 0 0 0 4.6 4.602h.002L4.107 19.96a3.59 3.59 0 0 1-2.112-2.111L.75 16.602Zm0 0a4.602 4.602 0 1 1 7.495 3.58h7.51a4.602 4.602 0 1 1 2.893 1.023H5.351l-1.245-1.246a3.58 3.58 0 1 0-2.112-2.112L.75 16.602Zm17.898 3.58a3.58 3.58 0 1 0 0-7.16 3.58 3.58 0 0 0 0 7.16Z",
      clipRule: "evenodd"
    }
  )
);
var SvgVoicemailDrop = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VoicemailDrop_default = SvgVoicemailDrop;

export { VoicemailDrop_default as default };
